import React from 'react';

const NotFound = () => (
    <div>
        <div className="container">
            <div className="row justify-content-md-center">
                <div className="mid">
                    <h4 className="Title Small mb-3">
                        The page you requested was not found, and we have a fine guess why.
                    </h4>
                    <div className='mb-3'>
                        <ul>
                            <li>* If you typed the URL directly, please make sure the spelling is correct.</li>
                            <li>* If you clicked on a link to get here, the link is outdated.</li>
                        </ul>
                    </div>
                    <h5><a href={'/main/'}>Go Home</a></h5>
                </div>
            </div>
        </div>
    </div>
);

export default NotFound;